module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/alert-39266cf0010e66ff9ce10262def71c27.svg";